























import { computed, defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { useStratifications } from '@/store/modules/stratifications';
import { Stratification } from '@/store/types';

export default defineComponent({
	components: { ConfirmDialog },
	inheritAttrs: false,
	props: {
		stratification: {
			type: Object as () => Stratification,
			required: true,
		},
	},
	setup(props, { root }) {
		const showConfirmationDialog = ref<boolean>(false);
		const { deleteStratification, clearError, isLoading, hasError, error: deleteError } = useStratifications(
			root.$store
		);
		const error = computed<string>(
			() =>
				deleteError.value?.response?.data?.message ||
				'An error occurred while attempting to delete a stratification. Please try again.'
		);

		const handleConfirmDelete = async () => {
			clearError();

			const success = await deleteStratification(props.stratification.id, true);

			if (success) {
				root.$store.dispatch('resources/getAllResources');
				showConfirmationDialog.value = false;
			}
		};

		return {
			showConfirmationDialog,
			handleConfirmDelete,
			clearError,
			isLoading,
			hasError,
			error,
		};
	},
});
